import { useEffect } from 'react';
import { getAuthData } from '@common/helpers/auth';

const ScawScript = () => {
  useEffect(() => {
    if (typeof document === 'undefined' || typeof window === 'undefined') return;
    if (document.querySelector('script[data-scaw-widget="true"]')) return;

    const script = document.createElement('script');
    script.async = true;
    script.setAttribute('data-scaw-widget', 'true');
    script.setAttribute('s', 'https://cdn.ml.bcua.io/animation/widget');
    script.src = `https://cdn.ml.bcua.io/animation/widget/widgetloader.js?ts=${+new Date()}`;

    document.head.appendChild(script);

    const queue = [];
    window.SCAW = function () {
      if (!arguments.length) return queue;
      if (window.__SCAWp) {
        const args = [...arguments];
        try {
          window.__SCAWp[args[0]].call(null, args[1]);
        } catch (err) {
          console.warn(
            `Error while calling ${args[0]} with argument ${args[1]}. Check documentation.`,
          );
        }
        queue.length = 0;
      }
      queue.push([...arguments]);
    };

    window.SCAW('_setClientInfo', { clientID: getAuthData().pid });
  }, []);

  return null;
};

export default ScawScript;
